import type { SceneContext } from '../_shared/types'
import type { WrappedData } from './types'
import { wrappedStat } from './tick'

export default function YearWrapped({ data, time }: SceneContext) {
  const d = data as unknown as WrappedData
  const { currentStat, animPhase } = wrappedStat(data, time)
  const stat = d.stats?.[currentStat]
  if (!stat) {
    return (
      <div className="pv-wrapped" style={{ background: (data as any).bgColor }}>
        <div className="pv-wrapped-end">See you next year! 🎉</div>
      </div>
    )
  }
  return (
    <div
      className="pv-wrapped"
      style={{ background: (data as any).bgColor || `linear-gradient(160deg, ${stat.color}15, ${stat.color}05)` }}
    >
      <div className="pv-wrapped-year">{d.year}</div>
      <div className={`pv-wrapped-emoji ${animPhase}`}>{stat.emoji}</div>
      <div className={`pv-wrapped-value ${animPhase}`}>{stat.value}</div>
      <div className="pv-wrapped-label">{stat.label}</div>
      <div className="pv-wrapped-counter">
        {currentStat + 1} / {d.stats.length}
      </div>
    </div>
  )
}
